import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { CookiesPolicyComponent } from './cookies-policy.component'

@NgModule({
  declarations: [CookiesPolicyComponent],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CookiesComponent: {
          component: () => import('./cookies-policy.component').then((c) => c.CookiesPolicyComponent)
        }
      }
    })
  ],
  exports: [CookiesPolicyComponent]
})
export class CookiesPolicyModule {}
